import { useEffect, useState } from 'react'
import { useSnackbar } from "notistack";
import { getCookie, getCookieNoCrypto } from '../Utils/CookieHelper';
import Service from '../Networking/NetworkingUtils';
import { Box, Button, Card, CardActions, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputAdornment, InputLabel, TextField, Tooltip, Typography, Stack, CardMedia, DialogContentText } from '@mui/material';
import VideoList from './OpenVideoList';
import { blobSAS } from '../Helper/BlobHelper';
import DownloadIcon from '@mui/icons-material/Download';
import OpenAssetList from './OpenAssetList';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import '../App.css'
import axios from 'axios';
import OpenAppList from './OpenAppList';
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment';
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { getDarkMode } from '../Helper/CommonThings';
import { msClientId } from '../Login/authProvider';

const dark = getCookie('theme_mode')

const OpenProjectStore = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState([]);
    const [dataCopy, setDataCopy] = useState([]);
    const [videoDialog, setVideoDialog] = useState(false);
    const [appDialog, setAppDialog] = useState(false);
    const [videos, setVideos] = useState([]);
    const [apps, setApps] = useState([]);
    const [assets, setAssets] = useState([]);
    const [projectName, setProjectName] = useState('');
    const [projectId, setProjectId] = useState(null);
    const [downloadDialog, setDownloadDialog] = useState(false);
    const [carousel, setCarousel] = useState(null);
    const [loading, setLoading] = useState(true);
    const [accessDialog, setAccessDialog] = useState(false)
    const [projectSasToken, setProjectSasToken] = useState(null)
    const [projectLogoSasToken, setProjectLogoSasToken] = useState(null)
    const [carouselSasToken, setCarouselSasToken] = useState(null)

    const getData = () => {
        Service.get('/api/projects/authentication/get_open_project/', {
            headers: {
                Authorization: getCookieNoCrypto('msal.' + msClientId + '.idtoken'),
            },
        }).then(res => {
            for (let index = 0; index < res.data.length; index++) {
                const element = res.data[index];
                for (let index = 0; index < element.assets.length; index++) {
                    const asset = element.assets[index];
                    if (asset.asset_platform === "web_gl") {
                        element.is_webgl = true
                    }
                    if (asset.asset_platform === "video") {
                        element.is_video = true
                    }
                    if (asset.asset_platform === "download") {
                        element.is_download = true
                    }
                    if (asset.asset_key === "cloud_gl") {
                        element.is_cloud_gl = true
                    }
                }
                if (!('is_webgl' in element)) {
                    element.is_webgl = false
                }
                if (!('is_video' in element)) {
                    element.is_video = false
                }
                if (!('is_download' in element)) {
                    element.is_download = false
                }
                if (!('is_cloud_gl' in element)) {
                    element.is_cloud_gl = false
                }
            }
            setData(res.data)
            setDataCopy(res.data)
            setLoading(false)
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
        }
        )
    }

    const getCarouselData = async () => {
        try {
            let tokenData = await blobSAS({ token_type: 'read_only', container_name: 'carousel' });
            setCarouselSasToken(tokenData);
            const response = await axios.get(tokenData.fd_account_url + '/carousel/carousel.json?' + tokenData.read_only['carousel'].sas_token);
            setCarousel(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getProjectSasToken = async () => {
        const tokenData = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
        setProjectSasToken(tokenData);
    }

    const getProjectLogoSasToken = async () => {
        const tokenData = await blobSAS({ token_type: 'read_only', container_name: 'client-info' });
        setProjectLogoSasToken(tokenData);
    }

    const handleAccessDialog = () => {
        setAccessDialog(false)
    }

    const sendRequest = () => {
        Service.post('/api/projects/authentication/user_request/', {
            headers: {
                Authorization: getCookieNoCrypto('msal.' + msClientId + '.idtoken'),
            },
            data: {
                'project': projectId,
            }
        }).then(res => {
            enqueueSnackbar('User request sent successfully!', {
                variant: 'success'
            })
            setAccessDialog(false)
        }).catch(error => {
            console.log(error)
            if (error.status === 406) {
                enqueueSnackbar(error.data.message, {
                    variant: 'warning'
                })
                return
            } else {
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            }
        }
        )

    }



    useEffect(() => {
        getData();
        getProjectSasToken();
        getCarouselData();
        getProjectLogoSasToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleVideos = (id) => {
        setVideoDialog(true)
        let video = []
        let assest_data = data[id]
        for (let index = 0; index < assest_data.assets.length; index++) {
            if (assest_data.assets[index].asset_platform === "video")
                video.push(assest_data.assets[index])
        }
        setVideos(video)
    }

    const handleApp = (id) => {
        setAppDialog(true)
        let app = []
        let assest_data = data[id]
        for (let index = 0; index < assest_data.assets.length; index++) {
            if (assest_data.assets[index].asset_platform === "web_gl")
                app.push(assest_data.assets[index])
        }
        setApps(app)
    }

    const handleAssets = (id) => {
        setDownloadDialog(true)
        let asset = []
        let assest_data = data[id]
        for (let index = 0; index < assest_data.assets.length; index++) {
            if (assest_data.assets[index].asset_platform === "download")
                asset.push(assest_data.assets[index])
        }
        setAssets(asset)
    }

    const handleVideoDialog = () => {
        setVideoDialog(false)
    }

    const handleDownloadDialog = () => {
        setDownloadDialog(false)
    }

    const handleAppDialog = () => {
        setAppDialog(false)
    }

    const handleSearch = (data) => {
        const data_lowercase = data.toLowerCase()
        var search_words = data_lowercase.split(" ");
        search_words = search_words.filter(n => n)
        var filtered_data = []
        if (search_words.length === 0) {
            filtered_data = dataCopy
        }

        for (let i = 0; i < dataCopy.length; i++) {
            const element = dataCopy[i];
            var num_of_passed = false
            for (let j = 0; j < search_words.length; j++) {
                const el = search_words[j];
                num_of_passed = element.name.toLowerCase().includes(el)
                if (!num_of_passed) {
                    break
                }
            }
            if (num_of_passed) {
                filtered_data.push(element)
            }
        }
        setData(filtered_data)
    }

    const cardComponent = (data, index) => {
        return (
            // <Grid item size={window.innerWidth <= 1650 ? 4 : 3} key={index} >
            //     <Card elevation={8} sx={{ borderRadius: '10px', height: '320px' }}>
            //         <img src={projectSasToken ? projectSasToken.fd_account_url + "/" + data.project_thumbnail + "?" + projectSasToken?.read_only?.['project-executables'].sas_token : ''} alt='' style={{ height: "200px", width: "100%", objectFit: 'cover' }} />
            //         <Box sx={{ m: 1 }}>
            //             <Box sx={{ mr: 1, fontWeight: "bold", fontSize: "large" }}>
            //                 {data.name}
            //             </Box>
            //             <Box sx={{ mt: 1, mr: 0.5, textOverflow: 'ellipsis', overFlow: 'hidden' }}>
            //                 {data.description}
            //             </Box>
            //             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            //                 <Button size="small" variant="contained" onClick={() => { setAccessDialog(true); setProjectName(data.name) }} sx={{ mr: 1 }}>
            //                     Access Request
            //                 </Button>
            //                 {data.is_video ?
            //                     <Button size="small" variant="contained" sx={{ mr: 1 }} onClick={() => { handleVideos(index); setProjectName(data.name) }}>Play Video</Button>
            //                     : null}
            //                 {data.is_webgl || data.is_cloud_gl ?
            //                     <Button size="small" variant="contained" sx={{ mr: 1 }} onClick={() => { handleApp(index); setProjectName(data.name) }}>Open App</Button>
            //                     : null}
            //                 {data.is_download ?
            //                     <Tooltip title="Downloadable Assets">
            //                         <IconButton size="small" variant="contained" sx={{ mr: 1 }} onClick={() => { handleAssets(index); setProjectName(data.name) }} >
            //                             <DownloadIcon sx={{ color: dark ? 'white' : null }} />
            //                         </IconButton>
            //                     </Tooltip> : null}
            //             </Box>
            //         </Box>
            //     </Card>
            // </Grid>
            <Grid item size={window.innerWidth <= 1650 ? 4 : 3} key={index} >
                <Card
                    elevation={8}
                    sx={{
                        height: '100%',
                        borderRadius: '10px',
                        overflow: "hidden",
                    }} >
                    <Box sx={{ position: "relative", p: 0.75 }}>
                        <CardMedia
                            component="img"
                            image={projectSasToken ? projectSasToken.fd_account_url + "/" + data.project_thumbnail + "?" + projectSasToken?.read_only?.['project-executables'].sas_token : ''}
                            alt=""
                            sx={{
                                height: 200,
                                width: '100%',
                                borderRadius: 1.5,
                                objectFit: "cover",
                            }} />
                        {data?.business_unit_details ?
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 14,
                                    right: 14,
                                    bgcolor: "rgba(78, 71, 71, 0.35)",
                                    color: "#fff",
                                    fontSize: 10,
                                    px: 1,
                                    py: 0.4,
                                    borderRadius: 0.75,
                                    backdropFilter: "blur(4px)",
                                }}
                            >
                                {data.business_unit_details.name}
                            </Box> : null}
                        {data?.client_details ?
                            <Box
                                sx={{
                                    position: "absolute",
                                    left: 16,
                                    bottom: -14,
                                    width: 52,
                                    height: 52,
                                    bgcolor: "#fff",
                                    borderRadius: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 8,
                                    fontWeight: 700,
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={projectLogoSasToken ? projectLogoSasToken.fd_account_url + '/' + data.client_details.logo + "?" + projectLogoSasToken?.read_only?.['client-info'].sas_token : ''}
                                    alt=""
                                    sx={{
                                        height: '100%',
                                        width: '100%',
                                        borderRadius: 2,
                                        objectFit: "cover",
                                        border: `1px solid ${getDarkMode() === 'dark' ? '#fff' : '#000'}`,
                                    }}
                                />
                            </Box> : null}
                    </Box>

                    <CardContent sx={{ pt: 2, px: 2, pb: 0 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            {data.name}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: 12,
                            }}
                        >
                            {data.description}
                        </Typography>
                    </CardContent>

                    <CardActions
                        sx={{
                            px: 2,
                            py: 1,
                            justifyContent: "space-between",
                        }}
                    >
                        <Stack direction="row" spacing={2.5}>
                            <Stack direction="row" spacing={0.6} alignItems="center">
                                <CalendarTodayOutlinedIcon sx={{ fontSize: 14 }} />
                                <Typography sx={{ fontSize: 10, }}>
                                    {data.date_created ? moment(data.date_created).format("DD-MM-YYYY") : ""}
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={0.6} alignItems="center">
                                <GroupsOutlinedIcon sx={{ fontSize: 16 }} />
                                <Typography sx={{ fontSize: 10, }}>
                                    {data.users_count}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <Button sx={{
                                textTransform: "none",
                                borderRadius: 5,
                                fontSize: 11,
                                px: 2.2,
                                mr: 1,
                                bgcolor: 'primary.main',
                                "&:hover": {
                                    bgcolor: "#087fc2",
                                },
                            }} size="small" variant="contained" onClick={() => { setAccessDialog(true); setProjectName(data.name); setProjectId(data.id) }} >
                                Access Request
                            </Button>
                            {props.isMsalAuthenticated ?
                                <div>
                                    {data.is_video ?
                                        <Button sx={{
                                            textTransform: "none",
                                            borderRadius: 5,
                                            fontSize: 11,
                                            px: 2.2,
                                            mr: 1,
                                            bgcolor: 'primary.main',
                                            "&:hover": {
                                                bgcolor: "#087fc2",
                                            },
                                        }} size="small" variant="contained" onClick={() => { handleVideos(index); setProjectName(data.name) }}>Play Video</Button>
                                        : null}
                                    {data.is_webgl || data.is_cloud_gl ?
                                        <Button sx={{
                                            textTransform: "none",
                                            borderRadius: 5,
                                            fontSize: 11,
                                            px: 2.2,
                                            mr: 1,
                                            bgcolor: 'primary.main',
                                            "&:hover": {
                                                bgcolor: "#087fc2",
                                            },
                                        }} size="small" variant="contained" onClick={() => { handleApp(index); setProjectName(data.name) }}>Open App</Button>
                                        : null}
                                    {data.is_download ?
                                        <Tooltip title="Downloadable Assets">
                                            <IconButton size="small" variant="contained" sx={{ mr: 1 }} onClick={() => { handleAssets(index); setProjectName(data.name) }} >
                                                <DownloadIcon sx={{ color: dark ? 'white' : null }} fontSize='small' />
                                            </IconButton>
                                        </Tooltip> : null}
                                </div> : null}
                        </Box>
                    </CardActions>
                </Card>
            </Grid>
        )
    }

    return (
        <div>
            {carousel ?
                <div style={{ height: '40vh', width: "100%", marginBottom: "15px", }}>
                    <Carousel
                        className="carousel-wrapper"
                        showArrows={true}
                        showStatus={false}
                        showThumbs={false}
                        infiniteLoop={true}
                        autoPlay={true}
                        interval={3000} >
                        {
                            carousel.map((data, index) => {
                                return (
                                    <div key={index} style={{ height: "100%", width: "100%" }}>
                                        <img src={carouselSasToken ? carouselSasToken.fd_account_url + "/carousel/" + data + "?" + carouselSasToken.read_only?.['carousel'].sas_token : ''} alt={index + "img"} style={{ height: "100%", width: "100%", objectFit: 'cover' }} />
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                </div> : null}
            <Divider variant="middle" sx={{ mb: 2, mt: 1 }} />
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>Project Store</Typography>
                <FormControl variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password"></InputLabel>
                    <TextField
                        id="outlined-adornment-password"
                        label="Search"
                        size="small"
                        variant='outlined'
                        onChange={(e) => handleSearch(e.target.value)}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                        }}
                        labelWidth={70}
                    />
                </FormControl>
            </Box>
            <Divider variant="middle" sx={{ mb: 2 }} />
            <div>
                {loading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'}><CircularProgress /></Box> :
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 6, sm: 8, md: 12 }}>
                        {data.map((data, index) => {
                            return (cardComponent(data, index))
                        })}
                    </Grid>
                }
            </div>
            <Dialog fullWidth={true} maxWidth="sm" open={videoDialog} onClose={handleVideoDialog}>
                <DialogTitle>{projectName} - Videos</DialogTitle>
                <VideoList videos={videos} />
                <DialogActions>
                    <Button sx={{
                        textTransform: "none",
                        borderRadius: 5,
                        fontSize: 11,
                        px: 2.2,
                        bgcolor: 'primary.main',
                        "&:hover": {
                            bgcolor: "#087fc2",
                        },
                    }} size='small' variant="contained" onClick={handleVideoDialog}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth="sm" open={appDialog} onClose={handleAppDialog}>
                <DialogTitle>{projectName} - Apps</DialogTitle>
                <OpenAppList apps={apps} />
                <DialogActions>
                    <Button sx={{
                        textTransform: "none",
                        borderRadius: 5,
                        fontSize: 11,
                        px: 2.2,
                        bgcolor: 'primary.main',
                        "&:hover": {
                            bgcolor: "#087fc2",
                        },
                    }} size='small' variant="contained" onClick={handleAppDialog}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth="sm" open={downloadDialog} onClose={handleDownloadDialog}>
                <DialogTitle>{projectName} - Downloadable Assets</DialogTitle>
                <OpenAssetList assets={assets} projectName={projectName} />
                <DialogActions>
                    <Button sx={{
                        textTransform: "none",
                        borderRadius: 5,
                        fontSize: 11,
                        px: 2.2,
                        bgcolor: 'primary.main',
                        "&:hover": {
                            bgcolor: "#087fc2",
                        },
                    }} size='small' variant="contained" onClick={handleDownloadDialog}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth="sm" open={accessDialog} onClose={handleAccessDialog}>
                <DialogTitle>{projectName} - Access Requests</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ textAlign: 'center' }}>
                        Are you sure you want to submit an access request for this project?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
                    <Button sx={{
                        textTransform: "none",
                        borderRadius: 5,
                        fontSize: 11,
                        px: 2.2,
                        bgcolor: 'primary.main',
                        "&:hover": {
                            bgcolor: "#087fc2",
                        },
                    }} size='small' variant="contained" onClick={handleAccessDialog}>Close</Button>
                    <Button sx={{
                        textTransform: "none",
                        borderRadius: 5,
                        fontSize: 11,
                        px: 2.2,
                        bgcolor: 'primary.main',
                        "&:hover": {
                            bgcolor: "#087fc2",
                        },
                    }} size='small' variant="contained" onClick={() => sendRequest()}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default OpenProjectStore